import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './Style/Global.css';

import Root from './Rooter/Root';
import ScrollToTop from './components/ScrollToTop';
import SiteLoader from './components/SiteLoader';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const minimumDelay = window.setTimeout(() => {
      setIsLoading(false);
    }, 900);

    return () => window.clearTimeout(minimumDelay);
  }, []);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Root />
      </BrowserRouter>
      {isLoading && <SiteLoader />}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
